// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1IdentitySchema } from './v1/identitySchema';

export const getCurrentUserIdentityHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string().describe("Bearer token")),
});

/**
 * @description user identity
 */
export const getCurrentUserIdentity200Schema = z.lazy(() => v1IdentitySchema);

/**
 * @description unauthorized
 */
export const getCurrentUserIdentity401Schema = z.unknown();

export const getCurrentUserIdentityQueryResponseSchema = z.lazy(() => getCurrentUserIdentity200Schema);
